import { memo, useEffect, useState } from "react";
import PaymentCard from "./payment.card/payment.card";
import { getQueryStringValue, PHONE_STATUS, PREVIEW_MODE } from "./common";

import { useTranslation } from "react-i18next";
import { fetchLayoutAPI } from "./apiSercive";
import { ILayout, IQuestionnaire, usePaymnetContext } from "..";
import InformationCard from "./Information.card/InformationCard";
import Loader from "../Loader/Loader";
import "./payment.checkout.scss";
import i18next from "i18next";


export const AppHeader = () => {
    const { state } = usePaymnetContext();
    const paymentDetails = JSON.parse(localStorage.getItem("pgvnext:paymentDetails") || "{}")


    if (state?.paymentDetail?.vendorId === "00000000-0000-0000-0000-000000000000") {
        return <header className="payment-header">
            <img className="payment-gateway" src={state.layout.topLeftLogo || paymentDetails.topLeftLogo || "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/azampay-white.svg"} alt="payemnt logo" />
            <img className="vendor-logo" src={state.layout.topRightLogo || paymentDetails.topRightLogo || "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/payment-gateway.svg"} alt="azampay" />
        </header>
    }

    return <header className="payment-header">
        <img className="payment-gateway" src={state.layout.topLeftLogo || paymentDetails.topLeftLogo || "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-icons/lipialink-white.svg"} alt="payemnt logo" />
        <img className="vendor-logo" src={state.layout.topRightLogo || paymentDetails.topRightLogo || "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/azampay-white.svg"} alt="azampay" />
    </header>
}
const PaymentCheckout = () => {
    const { state, update } = usePaymnetContext();
    const [loading, setLoading] = useState<boolean>(false)
    useEffect(() => {
        setLoading(true)
        if (state.mode === PREVIEW_MODE) {
            const layout: ILayout = {
                "topRightLogo": "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/azampay-white.svg",
                "topLeftLogo": "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-icons/lipialink-white.svg",
                "greetings": "Welcome to AzamPay Lipia Link",
                "poweredBy": `Powered by AzamPay Payment Gateway © ${new Date().getFullYear()} Visit: `,
                "bottomLogo": "https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-icons/lipalink-grey.svg.svg",
                "contactUsURL": "https://azampay.com/contact-us",
                "poweredByURL": "https://azampay.com/",
                "bottomMessage": "For further assistance, please",
                "questionnaire": [
                    {
                        "answer": "AzamPay's Payment Gateway is a quick and secure way for you to make digital payments.",
                        "question": "What is Payment Gateway?"
                    },
                    {
                        "answer": "With just a few clicks, you will be able to complete transactions through your mobile in a more secure way.",
                        "question": "How does it work?"
                    }
                ]
            }
            update({ ...state, layout })
            setLoading(false);
        } else {
            const id = getQueryStringValue("id") || "";
            fetchLayoutAPI(id, i18next.language).then((layout: ILayout) => {
                update({ ...state, layout })
                setLoading(false);
            });
            setLoading(false);
        }

    }, []);


    if (loading) return <div className="spinner-wrapper"><Loader /></div>
    return <section className="payment-checkout-page">
        <AppHeader />
        <PaymentComponent />
    </section>
}

const PaymentComponent = memo(() => {
    const { state } = usePaymnetContext();
    const { t, } = useTranslation();

    useEffect(() => {
        let successTimer: any = undefined;
        let failureTimer: any = undefined;
        if (state.status === "success") {
            successTimer = setTimeout(() => {
                window.location.href = state.paymentDetail?.redirectSuccessURL || "";
            }, 3000);
        } else if (state.status === "failed") {
            failureTimer = setTimeout(() => {
                window.location.href = state.paymentDetail?.redirectFailURL || "";
            }, 3000);
        }

        return () => {
            clearTimeout(successTimer);
            clearTimeout(failureTimer);
        };
    }, [state.status])

    return state.phoneStatus === PHONE_STATUS.CONFIRMED ?
        <InformationCard
            title={state.approveInApp ? t("sucessMsgApproveInApp") : t("hooray")}
            title2={state.approveInApp ? "" : t("successPayment")}
            desc={state.approveInApp ? t("confirmationMsgApproveInApp") : t("confirmationMsg", { vendorName: state.paymentDetail?.vendorName || state.paymentDetail?.appName, format: state.paymentDetail?.currency, value: t("intlNumber", { val: state.paymentDetail?.amount, locale: state.paymentDetail?.currency }) })}
            redirectText={t("goBack")}
            redirectURL={state.phoneStatus === PHONE_STATUS.CONFIRMED ? null : state.paymentDetail?.redirectSuccessURL}
        /> :
        <div className="payment-body">
            {/* <div className="payment-greetings">
                <div className="greetings-heading">{state.layout.greetings || t("greetings")}</div>
                {state.layout.questionnaire.length > 0 ? state.layout.questionnaire
                    .map((item: IQuestionnaire) =>
                        <QuestionAnswer key={item.question} question={item.question} answer={item.answer} />) :
                    <>
                        <QuestionAnswer question={t("question1")} answer={t("answer1")} />
                        <QuestionAnswer question={t("question2")} answer={t("answer2")} />
                    </>
                }
            </div> */}
            <PaymentCard />
        </div>
})

export const QuestionAnswer = ({ question, answer }: { question: string; answer: string }) => {
    return <div className="qa-wrapper">
        <div className="question">{question}</div>
        <div className="answer">{answer}</div>
    </div>
}


export default PaymentCheckout;